// extracted by mini-css-extract-plugin
export var createdDate = "_in-1";
export var divider = "_in-2";
export var headerDivider = "_in-3";
export var messagesCard = "_in-0";
export var messagesContainer = "_in-6";
export var messagesContainerWrapper = "_in-4";
export var showLeftPanelButton = "_in-8";
export var topButtons = "_in-7";
export var withPadding = "_in-5";